import PropTypes from "prop-types"
import { CssBaseline,  } from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"
import { default as Contact } from "./Contact/Form"
import { default as DocumentationMsc } from "./DocumentationMsc/Form"
import { default as JourneesPortesOuvertes } from "./JourneesPortesOuvertes/Form"
import { default as LPDocPsup } from "./LPDocPsup/Form"
import { default as LPAdmissionParallele } from "./LPAdmissionParallele/Form"
import { default as LPMaster } from "./LPMaster/Form"
import { default as LPPostBac } from "./LPPostBac/Form"
import { default as LPPostBacParcoursup } from "./LPPostBacParcoursup/Form"
import { default as LPProgrammesPostBac } from "./LPProgrammesPostBac/Form"
import { default as LPRentreeDecalee } from "./LPRentreeDecalee/Form"
import theme from "./Theme/index"
import { FormContextProvider } from "hooks/useForm"
import Forms from "../Forms"

const ContactISG = ({ campus, msc }) => {
  return (
    <FormContextProvider>
        <ThemeProvider theme={theme}>
          <Forms>
            <CssBaseline />
            <Contact campus={campus} msc={msc} />
          </Forms>
        </ThemeProvider>
    </FormContextProvider>
  )
}
const DocumentationMscISG = ({ campaignid, campus, msc, productid }) => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <DocumentationMsc campaignId={campaignid} campus={campus} msc={msc} productId={productid} />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}
const JourneesPortesOuvertesISG = () => {
  return (
    <FormContextProvider>
        <ThemeProvider theme={theme}>
          <Forms>
            <CssBaseline />
            <JourneesPortesOuvertes />
          </Forms>
        </ThemeProvider>
    </FormContextProvider>
  )
}
const LPHorizonISG = () => {
  return (
    <FormContextProvider>
        <ThemeProvider theme={theme}>
          <Forms>
            <CssBaseline />
            <LPDocPsup />
          </Forms>
        </ThemeProvider>
    </FormContextProvider>
  )
}

const LandingPageISG = ({ children }) => {
  return (
    <FormContextProvider>
        <ThemeProvider theme={theme}>
          <Forms>
            <CssBaseline />
            {children}
          </Forms>
        </ThemeProvider>
    </FormContextProvider>
  )
}
const LPRentreeDecaleeISG = () => <LandingPageISG><LPRentreeDecalee /></LandingPageISG>
const LPAdmissionParalleleISG = () => <LandingPageISG><LPAdmissionParallele /></LandingPageISG>
const LPMasterISG = () => <LandingPageISG><LPMaster /></LandingPageISG>
const LPPostBacISG = () => <LandingPageISG><LPPostBac /></LandingPageISG>
const LPPostBacParcoursupISG = () => <LandingPageISG><LPPostBacParcoursup /></LandingPageISG>
const LPProgrammesPostBacISG = () => <LandingPageISG><LPProgrammesPostBac variant="programmes-post-bac" /></LandingPageISG>
const LPProgrammesPostBacParcoursupISG = () => <LandingPageISG><LPProgrammesPostBac variant="programmes-post-bac-parcoursup" /></LandingPageISG>
const LPParcoursupPhaseComplementaireISG = () => <LandingPageISG><LPProgrammesPostBac variant="parcoursup-phase-complementaire" /></LandingPageISG>

LandingPageISG.propTypes = {
  children: PropTypes.node
}

DocumentationMscISG.propTypes = {
  campaignid: PropTypes.string,
  campus: PropTypes.string,
  msc: PropTypes.string,
  productid: PropTypes.string
}

ContactISG.propTypes = {
  campus: PropTypes.string,
  msc: PropTypes.string
}

export { ContactISG, DocumentationMscISG, JourneesPortesOuvertesISG, LPHorizonISG }
export { LPAdmissionParalleleISG, LPMasterISG, LPParcoursupPhaseComplementaireISG, LPPostBacISG, LPPostBacParcoursupISG, LPProgrammesPostBacISG, LPProgrammesPostBacParcoursupISG, LPRentreeDecaleeISG }
